module.exports = __webpack_public_path__ + "img/icon_del.533f863e.png";